import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5531972035157';
    const message = 'Olá, gostaria de fazer um orçamento de paineis de LED para meu evento.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button className="whatsapp-button" onClick={handleWhatsAppClick}>
      <i className="fab fa-whatsapp"></i>
      <span className="tooltip">Fale conosco no WhatsApp</span>
    </button>
  );
};

export default WhatsAppButton; 
